import React from 'react';
import PropTypes from 'prop-types';
import AutomationVariantPicker
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/DetailPicker/Details/Templates/AutomationSuggestionsPicker/AutomationSuggestions/Content/AutomationVariantPicker';
import { FDHeadlineText, FDStack } from '@facet-wealth/design';

const AutomationPicker = ({
  automationResource,
}) => {
  return (
    <FDStack paddingY={3} direction={'column'} spacing={2}>
      <FDHeadlineText size={'sm'} value={automationResource.attr('name')} />

      <FDStack direction={'column'} spacing={1}>
        {automationResource.attr('automationVariant').resources().list().map((automationVariantResource) => {
          return (
            <AutomationVariantPicker
              key={automationVariantResource.id()}
              resource={automationVariantResource}
            />
          );
        })}
      </FDStack>
    </FDStack>
  );
};

AutomationPicker.propTypes = {
  automationResource: PropTypes.object.isRequired,
};

export default AutomationPicker;
